module.exports = __webpack_public_path__ + "static/media/faq-mistake.03145598.svg";